import Vue from "vue";

const modulo_albaranes = {
    strict: false,

    state: {
        albaranes: [],
        current: 0,
        page: 1,
        // state que se usa para almacenar las ordenes seleccionadas para crear una factura desde "facturacion"
        albaranesData: []
    },

    getters: {
        getalbaranes: (state) => state.albaranes,
        getAlbaranesData: (state) => state.albaranesData,
    },

    mutations: {
        get_albaranes: (state, albaranes) => {
            state.albaranes = albaranes;
            state.page = 2;
        },
        update_albaranes: (state, albaranes) => {
            state.albaranes = state.albaranes.concat(albaranes.data);
            state.page = albaranes.current_page + 1;
        },
        add_search: (state, albaranes) => {
            state.albaranes = state.albaranes.concat(albaranes);
        },

        // mutaciones del estado ordenesData
        setAlbaranesData(state, data) {
            state.albaranesData = data;
        },
        clearAlbaranesData(state) {
            state.albaranesData = [];
        }
    },

    actions: {
        getAlbaranes: (context, vm) => {
            axios.get("api/get-albaranes?amount=15&page=1").then(
                (res) => {
                    console.log('albaranes', res.data.success.data);
                    context.commit("get_albaranes", res.data.success.data);
                },
                (res) => {}
            );
        },
        getAlbaranesWithId: (context, vm) => {
            axios.get(`api/get-albaranes?amount=15&page=1`).then(
                (res) => {
                    context.commit("get_albaranes", res.data.success.data);
                },
                (res) => {}
            );
        },
        getAlbaranNext: (context, vm) => {
            axios
                .get(
                    `api/get-albaranes?amount=15&page=${context.state.page ?? 1}`
                )
                .then(
                    (res) => {
                        context.commit("update_albaranes", res.data.success);
                    },
                    (res) => {}
                );
        },
        searchAlbaran: (context, vm) => {
            axios
                .get(
                    `api/get-albaranes?amount=15&page=1${
                        vm ? `&busqueda=${vm}` : ""
                    }`
                )
                .then(
                    (res) => {
                        context.commit("update_albaranes", res.data.success);
                    },
                    (res) => {}
                );
        },

        // Actions para establecer y remover ordenesData
        setAlbaranesData({ commit }, data) {
            commit('setAlbaranesData', data);
        },
        clearAlbaranesData({ commit }) {
            commit('clearAlbaranesData');
        }
    },
};

export default modulo_albaranes;
